import { DefinedValue, RealDefinedValue } from '@Alternatives/Model';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/CorporateAttributes/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class CorporateAttributesCommands extends VueCqrs 
{
	invokeDeleteCorporateAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, validate: boolean)
	{
		const cmd = new c.DeleteCorporateAttributeCommandV1(workspaceId, strategyId, attributeId, validate);
		this.$command(cmd, attributeId.toString());
	}

	invokeRenameCorporateAttributesSectionCommandV1(workspaceId: number, strategyId: string, oldName: string, newName: string)
	{
		const cmd = new c.RenameCorporateAttributesSectionCommandV1(workspaceId, strategyId, oldName, newName);
		this.$command(cmd);
	}


	invokeCreateCorporateNumericAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		const cmd = new c.CreateCorporateNumericAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues,
			minValue, maxValue, script, definedValues);

		this.$command(cmd);
	}

	invokeUpdateCorporateNumericAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		const cmd = new c.UpdateCorporateNumericAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues,
			minValue, maxValue, script, definedValues);

		this.$command(cmd, attributeId.toString());
	}


	invokeCreateCorporateDateAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: Date | null, maxValue: Date | null, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.CreateCorporateDateAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues,
			minValue, maxValue, definedValues);

		this.$command(cmd);
	}

	invokeUpdateCorporateDateAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: Date | null, maxValue: Date | null, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.UpdateCorporateDateAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues,
			minValue, maxValue, definedValues);

		this.$command(cmd, attributeId.toString());
	}


	invokeCreateCorporateEmailAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string,
		allowMultipleValues: boolean, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.CreateCorporateEmailAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues, definedValues);
		this.$command(cmd);
	}

	invokeUpdateCorporateEmailAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string,
		allowMultipleValues: boolean, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.UpdateCorporateEmailAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues, definedValues);
		this.$command(cmd, attributeId.toString());
	}


	invokeCreateCorporateTextAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.CreateCorporateTextAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues,
			minLength, maxLength, definedValues);
		this.$command(cmd);
	}

	invokeUpdateCorporateTextAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.UpdateCorporateTextAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, inputType, allowMultipleValues,
			minLength, maxLength, definedValues);
		this.$command(cmd, attributeId.toString());
	}


	invokeCreateCorporateMultilineAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, rows: number,
		minLength: number | null, maxLength: number | null)
	{
		const cmd = new c.CreateCorporateMultilineAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, rows,
			minLength, maxLength);
		this.$command(cmd);
	}

	invokeUpdateCorporateMultilineAttributeCommandV1(workspaceId: number, strategyId: string, attributeId: number, name: string, description: string, section: string, rows: number,
		minLength: number | null, maxLength: number | null)
	{
		const cmd = new c.UpdateCorporateMultilineAttributeCommandV1(workspaceId, strategyId, attributeId, name, description, section, rows,
			minLength, maxLength);
		this.$command(cmd, attributeId.toString());
	}
}